import { PFE_EXPRESSION, PfeExpressionCondition } from './expression.model';
import { PfeRulesEvaluator } from '../rules-evaluator';
import { PfeUserInputState } from './../../models/pfe-state/user-input-state.model';
import { ConditionEvaluator } from '../condition-evaluator.model';

export function pfeExpressionEvaluator() {
  return {
    type: PFE_EXPRESSION,
    evaluator: (pfeExpressionCondition: PfeExpressionCondition, state?: unknown): boolean =>
      PfeRulesEvaluator.evaluateCondition(pfeExpressionCondition, state as PfeUserInputState),
  } as ConditionEvaluator;
}
